import { DateTimeRange } from '@app/shared/date-range-picker/date-time-range';
import { TruckloadTemplateAttemptsSummary } from '@app/truckload-template-attempts/truckload-template-attempts';
import { TruckloadTemplateAttemptFilter } from '@app/truckload-template-attempts/truckload-template-attempts.service';
import { createAction, props } from '@ngrx/store';
import { DivisionLoadsSummary } from '../truckload';

export const initializeLoadStore = createAction(
	'[Truckload] Initialize Load Store',
	props<{ customerCode: string }>()
);

export const getNewLoadsSummaries = createAction(
	'[Truckload] Get New Division Loads Summaries',
	props<{ customerCode: string }>()
);

export const setNewLoadsSummaries = createAction(
	'[Truckload] Set New Division Loads Summaries',
	props<{ newLoadsSummaries: DivisionLoadsSummary[] }>()
);

export const setNewLoadsCounts = createAction(
	'[Truckload] Set New Division Loads Counts',
	props<{ newLoadsCount: number }>()
);

export const getActiveLoadsSummaries = createAction(
	'[Truckload] Get Active Division Loads Summaries',
	props<{ customerCode: string }>()
);

export const setActiveLoadsSummaries = createAction(
	'[Truckload] Set Active Division Loads Summaries',
	props<{ activeLoadsSummaries: DivisionLoadsSummary[] }>()
);

export const setActiveLoadsCounts = createAction(
	'[Truckload] Set Active Division Loads Counts',
	props<{ activeLoadsCount: number }>()
);

export const getCompletedLoadsSummaries = createAction(
	'[Truckload] Get Completed Division Loads Summaries',
	props<{ customerCode: string, dateTimeRange: DateTimeRange }>()
);

export const setCompletedLoadsSummaries = createAction(
	'[Truckload] Set Completed Division Loads Summaries',
	props<{ completedLoadsSummaries: DivisionLoadsSummary[] }>()
);

export const setCompletedLoadsCounts = createAction(
	'[Truckload] Set Completed Division Loads Counts',
	props<{ completedLoadsCount: number }>()
);

export const setSelectedDateTimeRange = createAction(
	'[Truckload] Set Completed Division Loads DateTime Range',
	props<{ selectedDateTimeRange: DateTimeRange }>()
);

export const getTruckloadTemplateAttempts = createAction(
	'[Truckload] Get truckload template attempts summary',
	props<{ filters: TruckloadTemplateAttemptFilter }>()
);

export const setTruckloadTemplateAttempts = createAction(
	'[Truckload] Set truckload template attempts summary',
	props<{ truckloadTemplateAttemptsSummary: TruckloadTemplateAttemptsSummary[] }>()
);

export const truckloadTemplateAttemptsError = createAction(
	'[Truckload] Truckload template attempts error',
	props<{ error: string }>()
);
